import React, { memo } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { useAuth } from "../../../core/contexts/AuthContext";
import { useTheme } from "../../../core/contexts/ThemeContext";

const menus = [
  {
    MenuHeader: "Operations",
    MenuNameNewPortal: "Vehicles",
    MenuLinkNewPortal: "/operations/vehicles"
  },
  {
    MenuHeader: "Manage",
    MenuNameNewPortal: "Geo boundary",
    MenuLinkNewPortal: "/manage/geoboundary"
  },
  {
    MenuHeader: "Manage",
    MenuNameNewPortal: "Roles",
    MenuLinkNewPortal: "/manage/roles"
  },
  {
    MenuHeader: "Manage",
    MenuNameNewPortal: "Users",
    MenuLinkNewPortal: "/manage/users"
  },
  {
    MenuHeader: "Reminders",
    MenuNameNewPortal: "Subcategory",
    MenuLinkNewPortal: "/reminder/subcategory"
  },
  {
    MenuHeader: "Reminders",
    MenuNameNewPortal: "Reminder Type",
    MenuLinkNewPortal: "/reminder/type"
  },
  {
    MenuHeader: "Reminders",
    MenuNameNewPortal: "Reminder List",
    MenuLinkNewPortal: "/reminder/list"
  },
  {
    MenuHeader: "Reminders",
    MenuNameNewPortal: "Reminder History",
    MenuLinkNewPortal: "/reminder/history"
  },
  {
    MenuHeader: "Reports",
    MenuNameNewPortal: "Unused Vehicles",
    MenuLinkNewPortal: "/reports/vehicles"
  },
];

const SideMenu = () => {
  const { authTokens } = useAuth();
  const location = useLocation();

  const { rucmonkeyTheme } = useTheme();

  const isActive = (name) => {
    let className = "";
    const pathname = location.pathname === "/" ? "/locate" : location.pathname;

    if (name.some((val) => pathname.includes(val))) {
      className = " active";
    }

    return className;
  };


  const setSubMenu = (menuHeader) => {
    return menus.map((item) => {
      if (item.MenuHeader === menuHeader) {
        return (
          <li key={item.MenuNameNewPortal}
            className={`sidebar-toggle ${isActive([item.MenuLinkNewPortal])}`}>
            <NavLink
              exact
              to={item.MenuLinkNewPortal}
              className="sidebar-toggle "
              activeClassName="set-nav-active"
            >
              <span className="sidebar-sub">{item.MenuNameNewPortal}</span>
            </NavLink>
          </li>
        );
      }
      else {
        return "";
      }
    });
  };


  return (
    <div
      className="sidebar"
      //data-color={rucmonkeyTheme && rucmonkeyTheme.sidebar.backgroundColor}
      data-color={rucmonkeyTheme?.sidebar.backgroundColor}
      data-active-color={rucmonkeyTheme?.sidebar.activeColor}
    >
      <div className="logo">
        {rucmonkeyTheme.style.logoUrl !== "" &&
          <span className="simple-text logo-mini">
            <div className="logo-image-small">
              <img src={rucmonkeyTheme && rucmonkeyTheme.style.logoUrl} alt="logo" />
            </div>
          </span>
        }
        <span className="simple-text logo-normal logo-sub-heading">
          {authTokens.account_name}
        </span>
        <div style={{ textAlign: "right" }}>
          v.{process.env.REACT_APP_SERVICE_VERSION}
        </div>
      </div>
      <div className="sidebar-wrapper">
        <ul className="nav ">

          <li className={`sidebar-toggle ${isActive(["/locate", "/history"])}`}>
            <NavLink
              exact
              to="/locate"
              className="sidebar-toggle "
              activeClassName="set-nav-active"
            >
              <i className=" nc-icon nc-pin-3"></i>
              <p>Locate</p>
            </NavLink>
          </li>
          <li className={` ${isActive(["/operations/"])}`}>
            <a
              data-toggle="collapse"
              href="#sideOperationMenu"
              aria-expanded="false"
              className=""
            >
              <i className="nc-icon nc-settings"></i>
              <p>
                Operations <b className="caret"></b>
              </p>
            </a>
            <div className="collapse" id="sideOperationMenu">
              <ul className="nav">
                {setSubMenu("Operations")}
              </ul>
            </div>
          </li>
          <li className={` ${isActive(["/manage/"])}`}>
            <a
              data-toggle="collapse"
              href="#sideManageMenu"
              aria-expanded="false"
              className=""
            >
              <i className="nc-icon nc-settings-gear-65"></i>
              <p>
                Manage <b className="caret"></b>
              </p>
            </a>
            <div className="collapse" id="sideManageMenu">
              <ul className="nav">
                {setSubMenu("Manage")}
              </ul>
            </div>
          </li>
          <li className={` ${isActive(["/reminder/"])}`}>
            <a
              data-toggle="collapse"
              href="#sideRemindersMenu"
              aria-expanded="false"
              className=""
            >
              <i className="nc-icon nc-bell-55"></i>
              <p>
                Reminders <b className="caret"></b>
              </p>
            </a>
            <div className="collapse" id="sideRemindersMenu">
              <ul className="nav">
                {setSubMenu("Reminders")}
              </ul>
            </div>
          </li>
          <li className={` ${isActive(["/reports/"])}`}>
            <a
              data-toggle="collapse"
              href="#sideReportsMenu"
              aria-expanded="false"
              className=""
            >
              <i className="nc-icon nc-paper"></i>
              <p>
                Reports <b className="caret"></b>
              </p>
            </a>
            <div className="collapse" id="sideReportsMenu">
              <ul className="nav">
                {setSubMenu("Reports")}
              </ul>
            </div>
          </li>


          <li>
            <a
              href="/login"
              className="sidebar-toggle "
            >
              <i className="nc-icon nc-share-66"></i>
              <p>Logout</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default memo(SideMenu);
